import { IAction, IState } from '../initialValues'

export const identityReducer = (state: IState, action: IAction): IState => {
    const actionHandlers: {
        [key: string]: (state: IState, payload: any) => IState
    } = {
        SET_SELECTED_FILE: (state, payload) => ({
            ...state,
            selectedFile: payload,
        }),
        SET_MODAL_OPEN: (state, payload) => ({
            ...state,
            isModalOpen: payload,
        }),
        SET_TEMP_FILE: (state, payload) => ({ ...state, tempFile: payload }),
    }

    const handler = actionHandlers[action.type]
    return handler ? handler(state, action.payload) : state
}
